export enum TOGGLE_SIZES {
  SMALL = 'small',
  LARGE = 'large',
}
